import { Icon, Icons } from '@Components/icon/Icon';
import { UboResponse } from '@Store/index';
import { AlertModal, LiliTextInput, Spinner, SpinnerColor } from '@lili/lili-frontend-common';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteBusinessOwner } from '../api/ownersCenter.api';

export interface UboItemProps {
  index: number;
  ubo: UboResponse;
  onEditClick: (uboId: string) => void;
  refetchBusinessOwners: () => void;
}

export const UboItem = (props: UboItemProps) => {
  const { index, ubo, onEditClick, refetchBusinessOwners } = props;
  const { t } = useTranslation();
  const { mutateAsync: deleteUbo, isPending: isDeletingUbo } = useDeleteBusinessOwner();
  const [isDeleteWarningModalOpen, setIsDeleteWarningModalOpen] = useState<boolean>(false);
  const fullName = `${ubo.firstName} ${ubo.lastName}`;

  const showDeleteWarningModal = () => {
    setIsDeleteWarningModalOpen(true);
  };

  const deleteUboHandler = async () => {
    await deleteUbo(ubo.externalId);
    refetchBusinessOwners();
    setIsDeleteWarningModalOpen(false);
  };

  return (
    <div className='flex items-center gap-[14px]'>
      <div className='w-full flex-1'>
        <LiliTextInput
          onChange={() => {}}
          id={`ownerDetails_${index}`}
          title={t('pages.ownersCenter.owner', { index: index + 2 })}
          disabled
          value={`${fullName} (${ubo.ownershipPercent}%)`}
          accessoryItemComponent={
            <div className='flex gap-[8px] justify-end items-center relative'>
              <Icon
                icon={Icons.Edit}
                className={'text-outline-primary-bw-07 cursor-pointer'}
                onClick={() => onEditClick(ubo.externalId)}
              />
              {isDeletingUbo ? (
                <span className='w-[16px]'>
                  <Spinner spinnerColor={SpinnerColor.Blue} height='16px' width='16px' />
                </span>
              ) : (
                <Icon
                  icon={Icons.Delete}
                  className={'text-outline-primary-bw-07 cursor-pointer'}
                  onClick={showDeleteWarningModal}
                />
              )}
            </div>
          }
        />
        {isDeleteWarningModalOpen && (
          <AlertModal
            title={t('pages.ownersCenter.removeOwner')}
            description={t('pages.ownersCenter.removeOwnerConfirmation', { name: fullName })}
            submitButtonTitle={t('pages.ownersCenter.remove')}
            cancelButtonTitle={t('pages.ownersCenter.cancel')}
            onSubmit={deleteUboHandler}
            onCancel={() => setIsDeleteWarningModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
